import { formatCurrency, formatDate } from "@utils/index";
import { Modal } from "@components/index";
import "./index.scss";

const VoucherDetailsModal = ({ isOpen, onClose, voucher }) => {
  if (!voucher) return null;

  const detailSections = [
    {
      title: "Voucher Information",
      fields: [
        { label: "Voucher Code", value: voucher.voucher_code },
        {
          label: "Voucher Value",
          value: formatCurrency(voucher.voucher_value),
        },
        {
          label: "Voucher Validity",
          value: formatDate(voucher.voucher_validity),
        },
        {
          label: "Redeemed Amount",
          value: formatCurrency(voucher.voucher_redeem_amount),
        },
      ],
    },
    {
      title: "Policy & Claim Details",
      fields: [
        { label: "Claim ID", value: voucher.claim_id },
        { label: "Policy Reference No", value: voucher.policy_reference_no },
        { label: "Plan Name", value: voucher.plan_name },
        {
          label: "Premium Amount",
          value: formatCurrency(voucher.premium_amount),
        },
      ],
    },
    {
      title: "Journey Details",
      fields: [
        { label: "Old PNR Number", value: voucher.old_pnr_number },
        {
          label: "Old Journey Date",
          value: formatDate(voucher.old_journey_date),
        },
        { label: "New PNR Number", value: voucher.new_pnr_number },
        {
          label: "New Journey Date",
          value: formatDate(voucher.new_journey_date),
        },
      ],
    },
    {
      title: "Booking Details",
      fields: [
        { label: "Chart Status", value: voucher.chart_status },
        { label: "Final Ticket Status", value: voucher.final_ticket_status },
        {
          label: "Confirmation Probability",
          value: `${voucher.confirmation_probability}%`,
        },
        {
          label: "Train Cancellation Status",
          value: voucher.train_cancellation_status,
        },
      ],
    },
    {
      title: "Financial Details",
      fields: [
        { label: "Fare Amount", value: formatCurrency(voucher.fare_amount) },
        {
          label: "Refund Amount",
          value: formatCurrency(voucher.refund_amount),
        },
        { label: "Refund Mode", value: voucher.refund_mode },
        { label: "Refund Transaction ID", value: voucher.refund_txn_id },
        { label: "Voucher Transaction ID", value: voucher.voucher_txn_id },
        {
          label: "Settlement DateTime",
          value: voucher.settlement_datetime
            ? new Date(voucher.settlement_datetime).toLocaleString()
            : "N/A",
        },
      ],
    },
    {
      title: "Customer Information",
      fields: [
        { label: "Customer Name", value: voucher.customer_name },
        { label: "Email", value: voucher.customer_email },
        { label: "Mobile Number", value: voucher.customer_mobile },
      ],
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="voucher-details-modal"
      showCloseIcon={false}
    >
      <div className="voucher-details-modal__header">
        <h2 className="voucher-details-modal__title">
          Voucher Details - {voucher.voucher_code}
        </h2>
        <button
          className="voucher-details-modal__close"
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
      </div>

      <div className="voucher-details-modal__content">
        {detailSections.map((section, index) => (
          <div key={index} className="voucher-details-modal__section">
            <h3 className="voucher-details-modal__section-title">
              {section.title}
            </h3>
            <div className="voucher-details-modal__fields">
              {section.fields.map((field, fieldIndex) => (
                <div key={fieldIndex} className="voucher-details-modal__field">
                  <span className="voucher-details-modal__label">
                    {field.label}:
                  </span>
                  <span className="voucher-details-modal__value">
                    {field.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default VoucherDetailsModal;
